<div class="chart-container" #chartContainer>
  <canvas #chartCanvas></canvas>
</div>
